<template>
  <component :is="tag" :class="classAttr" v-tooltip:[arguments]="texto" >
    <slot name="content"></slot>
  </component>
</template>

<script>

export default {
  name:'ToolTip',
  props:{
    tag:{
      type:String,
      default:'i'
    },
    placement:{
      type:String,
      default:'top'
    },
    texto:{
      type:String,
      default:''
    }
  },

  computed: {
    classAttr() {
      return this.$attrs.class || ''
    },

    arguments() {
      return { placement: this.placement }
    },
  },

  directives:{
    tooltip:{
      beforeMount(el, binding, vnode){
        $(el).tooltip({
          title: binding.value,
          placement: binding.arg.placement,
          trigger: 'hover',
          html: true
        })

        $(el).on('show.bs.tooltip', function() {
          const customClass = $(el).data("custom-class")
          let $tooltip = $(this).data('bs.tooltip');

          if (customClass) {
            $($tooltip.$tip).addClass(customClass);
          }
        });
      },
      unmounted(el) {
        try {
          $(el).tooltip('dispose');
        } catch (_) {
          // ignora: tooltip pode já ter sido destruído pelo Bootstrap quando o elemento sai do DOM
        }
      }
    }
  }
}
</script>

